import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => ({
  dialogRoot: {
    "& .MuiPickersCalendar-transitionContainer": {
      margin: 0
    }
  },
  dialogTitle: {
    display: "flex",
    fontSize: 16,
    padding: "0 8px 0 16px",
    borderBottom: "1px solid #d7d7d7",
    height: 48,
    "& > .MuiTypography-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flex: 1
    }
  },
  dialogCloseButton: {
    color: theme.palette.primary.dark
  },
  dialogCloseButtonIcon: {
    fontSize: 28
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    padding: 16,
    overflowX: "hidden"
  },
  dialogButtons: {
    display: "flex",
    justifyContent: "right",
    gap: 20
  },
  dialogButton: {
    flex: 1,
    padding: "8px 16px",
    whiteSpace: "nowrap"
  },
  dialogButtonsRemove: {
    background: theme.palette.warning.dark,
    color: theme.palette.common.white,
    "&.MuiButton-root:hover": {
      background: "#c53547"
    },
    "&.MuiButton-root.Mui-disabled": {
      background: "transparent"
    }
  },
  dialogPaper: {
    margin: 16
  },
  customDateButton: {
    width: 36,
    height: 36,
    minWidth: 36,
    borderRadius: "50%",
    border: "none",
    margin: "0 2px",
    color: theme.palette.common.black,
    background: "transparent",
    "&.MuiButton-root:hover": {
      background: "transparent"
    }
  },
  customDateButtonSelected: {
    color: theme.palette.common.white,
    background: theme.palette.common.black,
    "&.MuiButton-root:hover": {
      background: theme.palette.common.black
    }
  },
  customDatePreview: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: 106,
    borderTop: "1px solid #d7d7d7",
    gap: 6
  },
  customDatePreviewTitle: {
    fontSize: 14
  },
  customDatePreviewDate: {
    fontSize: 16,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  customDatePreviewDateFade: {
    fontSize: 14,
    color: theme.palette.text.hint
  }
}));
